import {
  CategoryRoomsArgs,
  useGetCategoryRoomsQuery,
} from "../../../../../api/categoryRooms/categoryRoomsApiSlice";

/**
 * Keeps an object-first category's room list loaded while its booking flow is
 * open (#3035). Renders nothing.
 *
 * A component of its own so the shell can mount it ONLY for an object-first
 * category: every other flow never subscribes to the slice, and the screens
 * read the cached list through `useObjectFirstEntry`. Mounted for the whole
 * flow rather than with the room list, so the picked room stays known on the
 * steps after it and is not evicted while the customer chooses a time.
 */
const CategoryRoomsSubscription = ({ args }: { args: CategoryRoomsArgs }) => {
  useGetCategoryRoomsQuery(args);
  return null;
};

export default CategoryRoomsSubscription;
